define(function(require,exports,module){
	var immediateAction = function(action, ticker, scope){
			return function(){
				action.call(scope);
			}
		},
		scheduleAction = function(action, ticker, scope){
			return function(){
				return setTimeout(function(){
					action.call(scope)
				},ticker);
			};
		};


	function Scheduler(immediate){
		this.actionQueue=[];
		this.executionQueue=[];

		if(immediate === true){
			this.scheduleAction = immediateAction;
			this.isImmediate = true;
		} else {
			this.scheduleAction = scheduleAction;
		}
	}

	Scheduler.prototype={
		isImmediate: false,
		ticker 	  : 0,
		addAction : function(action,timing,scope){
			this.actionQueue.push(
				this.scheduleAction(action, this.ticker+=timing, scope||this)
			);
		},
		run 	: function(){
			var i=0,
				items=this.actionQueue,
				len=items.length;
			
			for(; i<len; i++){
				this.executionQueue.push(items.shift()());
			}
			this.ticker=0;
		},
		clear 	: function(){
			if(!this.isImmediate){
				this.executionQueue.forEach(clearTimeout);
			}
			this.executionQueue=[];
			this.actionQueue=[];
		}
	}
	return Scheduler;
});